import { apply, onceToday, toast } from '../core/effects';
import { m } from '../i18n';
import { sfx } from '../audio/sfx';
import { h } from '../ui/dom';
import { openPhone, registerTab } from './phone';

const STATIONS = [
  { key: 'a', icon: '📻', url: 'https://youtube.com/@mebook888' },
  { key: 'b', icon: '🎵', url: 'https://youtube.com/playlist?list=PLB1PuqtbwVQnYd1AOnvVARNmJGgV5K4_-' },
  { key: 'c', icon: '🔬', url: 'https://youtube.com/channel/UCWdigI7S6VaNPs6ooIBbiwg' },
] as const;

function radio() {
  const t = m().phone.radio;
  return {
    title: t.title,
    body: [
      h('p', { class: 'hint pad' }, t.text),
      h(
        'div',
        { class: 'ph-list' },
        STATIONS.map((st) =>
          h(
            'a',
            {
              class: 'ph-item',
              href: st.url,
              target: '_blank',
              rel: 'noopener noreferrer',
              onclick: () => {
                sfx('ok');
                if (onceToday(`radio.${st.key}`)) apply({ mood: 5, stars: 2 });
                toast(m().phone.radio.opened);
              },
            },
            h('span', { class: 'av', style: 'background:#c0392b' }, st.icon),
            h('span', { class: 'info' }, h('b', null, t[st.key].name), h('small', null, t[st.key].sub)),
            h('span', { class: 'tm' }, '↗'),
          ),
        ),
      ),
    ],
  };
}

export function openRadio(): void {
  openPhone('radio');
}

export function initRadio(): void {
  registerTab('radio', radio);
}
